export class ContactForm {
    constructor(
        public debtNumber?: string,
        public firstname?: string,
        public lastname?: string,
        public phoneNumber?: string,
        public email?: string,
        public topic?: string,
        public topicTextValue?: string,
        public message?: string,
        public timeStamp?: string,
        public language?: string
    ) {}
}
